var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAutodeskAssistant = function SvgIconAutodeskAssistant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.426 10.136a1.297 1.297 0 1 0 0-2.595 1.297 1.297 0 0 0 0 2.595Z",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.202 10.993a2.155 2.155 0 1 0 0-4.31 2.155 2.155 0 0 0 0 4.31Z",
    fill: "#666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 3.887a1.297 1.297 0 1 0 0-2.594 1.297 1.297 0 0 0 0 2.594ZM23.2 30.762a1.297 1.297 0 1 0 0-2.595 1.297 1.297 0 0 0 0 2.595Z",
    fill: "gray"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.357 23.243a2.154 2.154 0 1 1-4.31 0 2.154 2.154 0 0 1 4.31 0ZM8.798 10.993a2.154 2.154 0 1 0 0-4.31 2.154 2.154 0 0 0 0 4.31Z",
    fill: "#666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.794 3.887a1.297 1.297 0 1 0 0-2.594 1.297 1.297 0 0 0 0 2.594ZM8.74 30.775a1.297 1.297 0 1 0 0-2.595 1.297 1.297 0 0 0 0 2.595Z",
    fill: "gray"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.952 23.243a2.154 2.154 0 1 1-4.308 0 2.154 2.154 0 0 1 4.308 0Z",
    fill: "#666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.725 23.28a1.297 1.297 0 1 1-2.594 0 1.297 1.297 0 0 1 2.594 0ZM2.6 10.136a1.297 1.297 0 1 0 0-2.595 1.297 1.297 0 0 0 0 2.595ZM3.897 23.283a1.297 1.297 0 1 1-2.594.006 1.297 1.297 0 0 1 2.594-.006Z",
    fill: "gray"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.293A2.646 2.646 0 1 0 16 0a2.646 2.646 0 0 0 0 5.293Z",
    fill: "#212121"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m13.37 13.68 5.023-9.902-5.039-1.2.016 11.102ZM16 32a2.646 2.646 0 1 0 0-5.293A2.646 2.646 0 0 0 16 32Z",
    fill: "#212121"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m18.63 18.32-5.023 9.902 5.039 1.2-.016-11.102ZM29.354 18.687a2.646 2.646 0 1 0 0-5.293 2.646 2.646 0 0 0 0 5.293Z",
    fill: "#212121"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m18.32 13.41 9.902 5.024 1.2-5.04-11.102.017ZM2.646 18.687a2.646 2.646 0 1 0 0-5.293 2.646 2.646 0 0 0 0 5.293Z",
    fill: "#212121"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m13.68 18.67-9.902-5.023-1.2 5.04 11.102-.017Z",
    fill: "#212121"
  })));
};
export default SvgIconAutodeskAssistant;